import { useFetchPageInfo } from "@/apis/queryFunctions/pageInfo";
import { useLocalContext } from "@/setup/locale-provider";
import sanitizeDOMData from "@/utils/sanitizeDOMData";
import { Box, Text, Title } from "@mantine/core";
import { useRouter } from "next/router";
import React from "react";

export default function Method() {
  const { getLabel } = useLocalContext();
  const { locale } = useRouter();
  const { data } = useFetchPageInfo("hinh-thuc-nop-ho-so", locale);

  const label = {
    vi: {
      title: "Hình thức nộp hồ sơ",
    },
    en: {
      title: "How to apply with us?",
    },
  };

  return (
    <div style={{ padding: "0 16px" }}>
      <Box
        sx={{
          // minWidth: 400,
          maxWidth: 500,
          minHeight: 50,
          // height: 50,
          background: "#fff",
          textAlign: "center",
          justifyContent: "center",
          padding: "10px 5px",
          marginBottom: 10,
          marginTop: 10,
        }}
      >
        <Title order={5} sx={{ height: "100%" }}>
          {getLabel(label[locale]?.title)}
        </Title>
      </Box>
      <Box
        sx={{
          // minWidth: 400,
          maxWidth: 500,
          //   maxHeight: 500,
          height: 520,
          background: "#f0f0f0",
          border: "1px solid #bababa",
          padding: "0px 0px 20px 20px",
          overflow: "hidden",
          // overflowX: "hidden",
          overflowY: "auto",
        }}
      >
        {data && (
          <div className="webview">
            <Text>{sanitizeDOMData(data?.content)}</Text>
          </div>
        )}
      </Box>
    </div>
  );
}
